import React from 'react';
import '../hojas-de-estilo/botonClear.css';

const BotonClear = (props) => ( //En realidad podemos solo poner "Clear" ahi en donde pusimos al children, ella solo quería jugar...
    <div className='boton-clear'
    onClick={props.manejarClear}>
        {props.children} 
    </div>
)

export default BotonClear;